import { logError } from 'App/services/coralogixService';
import { APIResponse } from 'Shared/services/apiInterface';
import { createUser, getAuthTokensUsingCredentials } from 'Shared/services/userActivation/api/idpApiService';

export const IDP_ERROR_UNKNOWN_DEVICE_ID                  = 107;
export const IDP_ERROR_CODE_PASSWORD_EXPIRED              = 109;
export const IDP_ERROR_CODE_GENERIC                       = -1;

/**
 * Creates a new user at signup
 * @param firstName
 * @param lastName
 * @param email
 * @param password
 * @param marketingOptIn
 * @param impactClickId
 * @param gclid
 * @param fbclid
 * @param msclkid
 */
const createNewUser = (email: string, password: string, marketingOptIn =true): Promise<APIResponse | null> => {
  // Create user in IDP. Retrieve user ID
  return new Promise((resolve, reject) => {
    createUser(email, password, marketingOptIn)
      .then(() => {
        return getAuthTokensUsingCredentials(email, password);
      })
      .then(() => {
        resolve(null);
      })
      .catch((error) => {
        logError('createUser', error);
        reject(error);
      });
  });
};

export {
  createNewUser
};
